// extracted by mini-css-extract-plugin
module.exports = {"content":"SampleJSON_content__OIDK1","link":"SampleJSON_link__ySkBj"};